// eslint-disable-next-line import/prefer-default-export
export const INTERLOCK_TYPES = {
  obstacle: 'OBSTACLE',
  dependency: 'DEPENDENCY',
  question: 'QUESTION',
  decision: 'DECISION',
};
